import React, { useContext } from "react";
import ApiService from "./ApiService";
import * as Sentry from "@sentry/react";
import { AuthContext } from "./AuthContext";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import CryptoJS from "crypto-js";
import { toast } from "react-toastify";
import MasterCardIcon from "../../component/images/card1.png";
import VisaCardIcon from "../../component/images/logos_visa.png";
import AmrecanExpressIcon from "../../component/images/americanExpressIcon.png";
import DinerClubIcon from "../../component/images/DinersClubIcon.png";
import DiscoverCardIcon from "../../component/images/discoverCardIcon.png";
import JCBCardIcon from "../../component/images/jcbcardIcon.png";
import UnionPayIcon from "../../component/images/unionPayIcon.png";
import CardIcon from "../../component/images/cardIcon.png";
import { v4 as uuidv4 } from "uuid";
const Functions = () => {
  // LOCICAL VARIABLES

  const {
    user,
    setUser,
    socket,
    app_js_intialLoad,
    channelParameters,
    setIsInCall,
    setIsCallMinimized,
    setCallMetadata,
    callMetadata,
    pauseAudio,
    receive_call_audio,
    audioChannel,
    resetCallState,
    endCallFunctionRef,
    isInCall,
  } = useContext(AuthContext);
  const { get_user_details, get_patient_user_details, log_out } = ApiService();

  const navigate = useNavigate();

  const consoleService = (text, data) => {
    const isData = data != undefined;
    if (process.env.REACT_APP_CONSOLE_LOG == "true") {
      if (isData) {
        console.log(text, data);
      } else {
        console.log(text);
      }
    }
  };

  const formet_date = (stamp) => {
    // January 2, 1940
    const optionsDate = {
      day: "numeric",
      month: "short",
      year: "numeric",
    };

    const dateObject = new Date(stamp);
    return dateObject.toLocaleDateString("en-US", optionsDate);
  };

  const formet_time = (stamp) => {
    const optionsTime = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    const timeObject = new Date(stamp);
    return timeObject.toLocaleTimeString("en-US", optionsTime);
  };

  const scheduledTimeForTherapist = (therapistPricing, patientPriceId) => {
    if (!Array.isArray(therapistPricing) || !patientPriceId) return null;
    const priceObj = therapistPricing.find(
      (item) => item?.id == patientPriceId
    );
    if (!priceObj) return null;
    const { time_in_min } = priceObj;
    if (time_in_min == 30) {
      return `30 min`;
    } else if (time_in_min == 60) {
      return "1 hr";
    }
    return null;
  };

  const scheduledTimeSlotForTherapist = (therapistPricing, patientPriceId) => {
    if (!Array.isArray(therapistPricing) || !patientPriceId) return null;
    const priceObj = therapistPricing.find(
      (item) => item?.id == patientPriceId
    );
    if (!priceObj) return null;
    const { time_in_min } = priceObj;
    return time_in_min;
  };

  const get_price = (therapistPricing, patientPriceId) => {
    if (!Array.isArray(therapistPricing) || !patientPriceId) return null;
    const priceObj = therapistPricing.find(
      (item) => item?.id == patientPriceId
    );
    if (!priceObj) return null;
    const { price } = priceObj;
    return price;
  };
  const get_upcoming_timp_diff = (date, time) => {
    const targetDateTime = new Date(date);
    const timeStamp = new Date(time);
    targetDateTime.setHours(timeStamp.getHours());
    targetDateTime.setMinutes(timeStamp.getMinutes());

    const currentDateTime = new Date();

    const differenceInMilliseconds = targetDateTime - currentDateTime;
    if (differenceInMilliseconds < 0) {
      const absoluteDifference = Math.abs(differenceInMilliseconds);

      const seconds = Math.floor(absoluteDifference / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);
      const months = Math.floor(days / 30);
      const years = Math.floor(days / 365);

      if (years > 0) {
        return `${years} year${years > 1 ? "s" : ""} ago`;
      } else if (months > 0) {
        return `${months} month${months > 1 ? "s" : ""} ago`;
      } else if (days > 0) {
        return `${days} day${days > 1 ? "s" : ""} ago`;
      } else if (hours > 0) {
        return `${hours} hour${hours > 1 ? "s" : ""} ago`;
      } else if (minutes > 0) {
        return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
      } else {
        return "just now";
      }
    } else {
      const seconds = Math.floor(differenceInMilliseconds / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);
      const months = Math.floor(days / 30);
      const years = Math.floor(days / 365);

      if (years > 0) {
        return `${years} year${years > 1 ? "s" : ""}`;
      } else if (months > 0) {
        return `${months} month${months > 1 ? "s" : ""}`;
      } else if (days > 0) {
        return `${days} day${days > 1 ? "s" : ""}`;
      } else if (hours > 0) {
        return `${hours} hour${hours > 1 ? "s" : ""}`;
      } else if (minutes > 0) {
        return `${minutes} minute${minutes > 1 ? "s" : ""}`;
      } else {
        return `${seconds} second${seconds > 1 ? "s" : ""}`;
      }
    }
  };

  function calculateAge(date) {
    const birthday = new Date(date);
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  const enctyptDataFun = (data) => {
    const endata = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      process.env.REACT_APP_CRYPTO_KEY
    ).toString();
    return endata;
  };

  // DECRYPT DATA FUNCTION

  function decryptData(key) {
    const encryptedData = localStorage.getItem(key);
    consoleService("encryptedData in decryptData 12=", encryptedData);
    if (encryptedData) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          encryptedData,
          process.env.REACT_APP_CRYPTO_KEY
        );
        const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        consoleService("decryptedData  decryptData atfter 12=", decryptedData);
        return decryptedData;
      } catch (error) {
        console.error("Decryption failed:", error.message);
        return null;
      }
    }

    return null;
  }

  // SET RUNNING CALL ID

  const setRunningCallId = async (id) => {
    try {
      const encryptedId = enctyptDataFun(id);
      localStorage.setItem("E_C_C_R_D", encryptedId);
      return;
    } catch (err) {
      consoleService("error in setRunningCallIdFun =", err);
    }
  };

  //  RUNNING CALL ID

  const get_running_call_id = () => {
    try {
      const decryptedData = decryptData("E_C_C_R_D");
      if (!decryptedData) return null;
      const found_details = JSON.parse(decryptedData);
      return found_details;
    } catch (err) {
      consoleService(" error in get_running_call_id  =", err);
      return null;
    }
  };

  const set_user_details = async () => {
    try {
      const res = await get_user_details();
      if (res?.status === 1 && res?.data) {
        localStorage.setItem("E_C_U_D", enctyptDataFun(res.data));
        return setUser({ ...user, details: res.data });
      }
    } catch (err) {
      consoleService("error in set_user_details", err);
    }
  };

  const set_patient_user_details = async () => {
    try {
      const res = await get_patient_user_details();
      if (res?.status === 1 && res?.data) {
        localStorage.setItem("E_C_U_D", enctyptDataFun(res.data));
        return setUser({ ...user, details: res.data });
      }
    } catch (err) {
      consoleService("error in set_patient_user_details", err);
    }
  };

  const logOut = async () => {
    try {
      // IMPORTANT: End active call BEFORE logging out
      if (isInCall && endCallFunctionRef.current) {
        try {
          // Detect call type from callMetadata and call appropriate end function
          const isVideoCall = callMetadata?.callType === "video";

          if (isVideoCall && endCallFunctionRef.current.endVideoCall) {
            await endCallFunctionRef.current.endVideoCall();
          } else if (!isVideoCall && endCallFunctionRef.current.endAudioCall) {
            await endCallFunctionRef.current.endAudioCall();
          }

          // Wait a bit for call cleanup to complete
          await new Promise((resolve) => setTimeout(resolve, 500));
        } catch (callEndError) {
          console.error("Error ending call during logout:", callEndError);
          // Continue with logout even if call end fails
        }
      }

      const res = await log_out();
      if (res?.status === 1) {
        // Stop ringtone using global reference
        if (window.activeRingtone) {
          window.activeRingtone.pause();
          window.activeRingtone.currentTime = 0;
          window.activeRingtone.loop = false;
          window.activeRingtone = null;
        }

        // Also stop through context reference
        if (receive_call_audio) {
          receive_call_audio.pause();
          receive_call_audio.currentTime = 0;
        }

        // Call pauseAudio function
        pauseAudio();

        // Dismiss all toasts
        toast.dismiss();

        // IMPORTANT: Clear call states BEFORE navigation and localStorage.clear
        // This ensures the confirmation dialog doesn't appear on re-login

        setIsInCall(false);
        setIsCallMinimized(false);
        setCallMetadata({
          callType: "",
          sendingCall: false,
          receivingCall: false,
          mute_audio: false,
          hide_video: false,
          showMessage: "",
          callDuration: 0,
          localVideoTrack: null,
          remoteVideoTrack: null,
          localAudioTrack: null,
          remoteAudioTrack: null,
          userName: "",
        });

        // Reset unified call state
        resetCallState();

        // Close Agora tracks
        if (channelParameters?.localVideoTrack) {
          channelParameters.localVideoTrack.close();
        }
        if (channelParameters?.localAudioTrack) {
          channelParameters.localAudioTrack.close();
        }

        // Disconnect socket
        socket && socket.disconnect();
        if (app_js_intialLoad?.current !== undefined) {
          app_js_intialLoad.current = false;
        }

        // Clear Sentry user context on logout
        Sentry.setUser(null);

        // Clear localStorage and navigate
        localStorage.clear();
        navigate("/", { replace: true });

        localStorage.setItem(
          "E_C_O_L_W_S",
          enctyptDataFun({ warning_seen_status: false })
        );
        return setUser({
          access_token: null,
          details: null,
        });
      }
    } catch (err) {
      consoleService("error in logout function", err);
    }
  };

  const get_day = (date) => {
    let day = "";
    switch (new Date(date).getDay()) {
      case 0:
        day = "Sun";
        break;
      case 1:
        day = "Mon";
        break;
      case 2:
        day = "Tue";
        break;
      case 3:
        day = "Wed";
        break;
      case 4:
        day = "Thu";
        break;
      case 5:
        day = "Fri";
        break;
      case 6:
        day = "Sat";
    }
    return day;
  };

  const combine_time_to_date = (date, time) => {
    const timeStamp = new Date(time);
    const dateStamp = new Date(date);
    return new Date(
      dateStamp.getFullYear(),
      dateStamp.getMonth(),
      dateStamp.getDate(),
      timeStamp.getHours(),
      timeStamp.getMinutes(),
      timeStamp.getSeconds()
    );
  };

  const getStars = (fillStar, emptyStar, noOfStart) => {
    const starts = [];
    for (let a = 0; a < 5; a++) {
      if (a < noOfStart) {
        starts.push(fillStar);
      } else {
        starts.push(emptyStar);
      }
    }
    return starts;
  };

  function get_chat_time(timestamp) {
    const momentDate = moment(timestamp);
    const now = moment();
    const oneDayAgo = now.clone().subtract(1, "day");

    if (momentDate.isSame(now, "day")) {
      // Today
      return `Today ${momentDate.format("hh:mm a")}`;
    } else if (momentDate.isSame(oneDayAgo, "day")) {
      // Yesterday
      return `Yesterday ${momentDate.format("hh:mm a")}`;
    } else {
      // Other days
      return `${momentDate.format("dddd hh:mm a")}`;
    }
  }

  function checkActiveTimeSlots(start_time, end_time) {
    const startTime = new Date(start_time);
    const endTime = new Date(end_time);
    const currentTime = new Date();

    if (currentTime >= startTime && currentTime <= endTime) {
      return true;
    } else {
      return false;
    }
  }

  const get_gender = (gender) => {
    if (gender == "Male") {
      return "M";
    } else if (gender == "Female") {
      return "F";
    } else {
      return "U";
    }
  };
  const isLastPage = (page_num, totalDocs, limit) => {
    const totalPages = Math.ceil(Number(totalDocs) / Number(limit));
    if (page_num < totalPages) {
      return false;
    } else {
      return true;
    }
  };

  const formetDate = (date) => {
    // 01/01/1940
    return `${String(new Date(date).getMonth() + 1).padStart(2, "0")}-${String(
      new Date(date).getDate()
    ).padStart(2, "0")}-${new Date(date).getFullYear()}`;
  };
  const formatDateForExpiryDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${month}-${day}-${year}`;
  };

  function capitalizeFirstLetter(str) {
    if (!str || typeof str !== "string") return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const formatDateFromUTC = (date) => {
    const utcDate = new Date(date);
    return `${String(utcDate.getUTCMonth() + 1).padStart(2, "0")}-${String(
      utcDate.getUTCDate()
    ).padStart(2, "0")}-${utcDate.getUTCFullYear()}`;
  };

  const extractQueryFromUrl = (url) => {
    try {
      if (!url || typeof url !== "string") return "";
      const urlObject = new URL(url);
      const queryString = urlObject.search;
      return queryString;
    } catch (err) {
      consoleService("error in extractQueryFromUrl", err);
      return "";
    }
  };

  const simpleArrayString = (item, index, array) => {
    // first ,second , thirt.
    if (!Array.isArray(array) || array.length === 0) return "";
    const start_index = 0;
    const last_index = array.length - 1;

    if (index == start_index && last_index == index) {
      return `${item}.`;
    } else if (index != last_index) {
      return `${item}, `;
    } else {
      return `${item}.`;
    }
  };

  function getCardBrandIconPath(cardBrand) {
    if (!cardBrand || typeof cardBrand !== "string") return CardIcon;
    switch (cardBrand.toLowerCase()) {
      case "visa":
        return VisaCardIcon;
      case "mastercard":
        return MasterCardIcon;
      case "american express":
        return AmrecanExpressIcon;
      case "discover":
        return DiscoverCardIcon;
      case "jcb":
        return JCBCardIcon;
      case "diners club":
        return DinerClubIcon;
      case "unionpay":
        return UnionPayIcon;
      default:
        return CardIcon;
    }
  }

  const formatCallDuration = (callDuration) => {
    const minutes = Math.floor(callDuration / 60);
    const seconds = callDuration % 60;

    const formattedTime = `${String(minutes).padStart(2, "0")}:${String(
      seconds
    ).padStart(2, "0")}`;

    return formattedTime;
  };

  const get_day_from_foreign_time = (date, time_zone) => {
    const localDate = new Date(date);
    const ForeignDate = localDate.toLocaleString("en-US", {
      timeZone: time_zone,
    });

    const dayOfWeekForeign = new Date(ForeignDate).getDay();

    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    const day = daysOfWeek[dayOfWeekForeign];
    return day;
  };

  function adjustSecondTimestamp(firstTimestamp, secondTimestamp) {
    const firstDate = new Date(firstTimestamp);
    const secondDate = new Date(secondTimestamp);

    // Calculate the hour and minute difference
    const hoursDiff = secondDate.getUTCHours();
    const minutesDiff = secondDate.getUTCMinutes();

    // Adjust secondDate to have the same year, month, and day as firstDate
    secondDate.setUTCFullYear(firstDate.getUTCFullYear());
    secondDate.setUTCMonth(firstDate.getUTCMonth());
    secondDate.setUTCDate(firstDate.getUTCDate());

    // Set the hours and minutes to match the original difference
    secondDate.setUTCHours(hoursDiff);
    secondDate.setUTCMinutes(minutesDiff);
    secondDate.setUTCSeconds(0);

    // Set the seconds of firstDate to 0
    firstDate.setUTCSeconds(0);

    // If the adjusted secondDate is earlier than the firstDate, add one day to secondDate
    if (secondDate < firstDate) {
      secondDate.setUTCDate(secondDate.getUTCDate() + 1);
    }

    return {
      firstDate: firstDate.toISOString(),
      secondDate: secondDate.toISOString(),
    };
  }

  function getConversationTime(call_start_time, call_end_time) {
    // Convert to Date objects

    if (!call_start_time || !call_end_time) {
      return "00:00";
    }
    const start = new Date(call_start_time);
    const end = new Date(call_end_time);

    // Calculate difference in seconds
    const diffInSeconds = Math.floor((end - start) / 1000);

    // Convert to minutes and seconds
    const minutes = Math.floor(diffInSeconds / 60);
    const seconds = diffInSeconds % 60;

    // Format as MM:SS
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  }

  const fileToBase64 = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
    });
  };

  const get_unique_id = () => {
    const uniqueId = uuidv4();
    return uniqueId;
  };

  const get_simple_year_date_month_str = (date) => {
    return moment(date).format("MM-DD-YYYY");
  };

  function localDateFromString(ymd) {
    if (!ymd || typeof ymd !== "string") return null;
    try {
      const parts = ymd.split("-");
      if (parts.length !== 3) return null;
      const [y, m, d] = parts.map(Number);
      if (isNaN(y) || isNaN(m) || isNaN(d)) return null;
      return new Date(y, m - 1, d); // midnight LOCAL, not UTC
    } catch (err) {
      consoleService("error in localDateFromString", err);
      return null;
    }
  }
  const split_simple_year_date_month_from_str = (dateString) => {
    if (!dateString || typeof dateString !== "string") return "";
    try {
      // Take only the date part before "T"
      const dateOnly = dateString.split("T")[0]; // "1997-01-24"
      const parts = dateOnly.split("-");
      if (parts.length !== 3) return "";
      const [y, m, d] = parts;
      return `${y}-${m}-${d}`;
    } catch (err) {
      consoleService("error in split_simple_year_date_month_from_str", err);
      return "";
    }
  };
  function formatYMD(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0"); // ensures 01-12
    const d = String(date.getDate()).padStart(2, "0"); // ensures 01-31
    return `${y}-${m}-${d}`;
  }
  return {
    consoleService,
    formet_date,
    formatDateForExpiryDate,
    formatDateFromUTC,
    formet_time,
    scheduledTimeForTherapist,
    get_upcoming_timp_diff,
    calculateAge,
    set_user_details,
    logOut,
    get_day,
    combine_time_to_date,
    scheduledTimeSlotForTherapist,
    getStars,
    get_chat_time,
    checkActiveTimeSlots,
    get_gender,
    get_price,
    isLastPage,
    formetDate,
    enctyptDataFun,
    decryptData,
    set_patient_user_details,
    capitalizeFirstLetter,
    extractQueryFromUrl,
    simpleArrayString,
    getCardBrandIconPath,
    formatCallDuration,
    get_day_from_foreign_time,
    adjustSecondTimestamp,
    getConversationTime,
    setRunningCallId,
    get_running_call_id,
    fileToBase64,
    get_unique_id,
    get_simple_year_date_month_str,
    localDateFromString,
    split_simple_year_date_month_from_str,
    formatYMD,
  };
};

export default Functions;
